import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { connect, useSelector } from "react-redux";

import "./login.css";
import axiosClient from "api/index.js";

const VerifyEmail = () => {
  const { token } = useParams();
  const [showState, setShowState] = useState(false);
  const [verified, setVerified] = useState(false);
  const auth = useSelector((state) => state.auth);

  let history = useHistory();

  useEffect(() => {
    axiosClient
      .post("/public/verify-email-token", { token })
      .then((res) => {
        setShowState(true);
        setVerified(true);
      })
      .catch((error) => {
        setShowState(true);
        console.error(error);
      });
  }, [token]);

  useEffect(() => {
    // Wait until the verify-token request has resolved before redirecting.
    if (!showState) return undefined;

    const timer = setTimeout(() => {
      if (!verified) {
        history.push("/");
        return;
      }
      if (auth.isAuthenticated) {
        // Already logged in (verified from the same browser they signed up in):
        // members who finished the service-setup steps go to the dashboard,
        // everyone else goes back to finish those steps.
        history.push(auth.user?.isServiceRegisted ? "/dashboard" : "/service");
      } else {
        // Verified on a different device/browser — send them to log in; the
        // login flow will then route them based on their setup status.
        history.push("/login?verify=true");
      }
    }, 3000);

    return () => clearTimeout(timer);
  }, [showState, verified, auth, history]);

  return (
    <div className="login-form-container">
      <form className="forgot-form">
        <div className="px-12">
          <p className="login-text-login">Email verification</p>

          {showState ? (
            <>
              {verified ? (
                <p className="py-[20px] text-center">
                  <span className="text-main">
                    Congratulations! Your account is verified.
                  </span>
                  <br />
                  Redirecting...
                </p>
              ) : (
                <p className="py-[20px] text-center">
                  <span className="text-red-600">
                    Invalid link! Please try with correct link.
                  </span>
                  <br />
                  Redirecting...
                </p>
              )}
            </>
          ) : (
            <p>Waiting...</p>
          )}
        </div>
      </form>
    </div>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});
export default connect(mapStateToProps, {})(VerifyEmail);
